/* global Pjax */
var pjax;

document.addEventListener("pjax:send", function() {
   jQuery('header').addClass('headroom--loading');
   jQuery('.loading-mask, main').removeClass('completed');
   setTimeout(function(){
      closeMenu();
   }, 75);
})

document.addEventListener("pjax:complete", function() {

   jQuery('.loading-mask').addClass('completed');

   /* function defined in header atom */
   headerComplete();
   textImage();
   forms();

   jQuery('.block.contact .right-top-grid a').click(function(){
      jQuery('html, body').animate({
         scrollTop: (jQuery(".block.form").offset().top - 120)
      }, 1200);
   });
});

document.addEventListener("pjax:error", function() {
   console.log("Event: pjax:error", arguments)
})

document.addEventListener("pjax:success", function() {
   console.log("Event: pjax:success", arguments);
})

document.addEventListener("DOMContentLoaded", function() {

   jQuery('main, .loading-mask').addClass('completed');

   jQuery( document ).bind( 'gform_post_render', function() {
      var gfRecaptchaPoller = setInterval( function() {
         if( ! window.grecaptcha || ! window.grecaptcha.render ) {
            return;
         }
         renderRecaptcha();
         clearInterval( gfRecaptchaPoller );
      }, 100 );
   } );

   pjax = new Pjax({
      elements: 'a:not(.no-pjax):not([target="_blank"])',
      selectors: ["head title", ".blocks-wrapper"],
      switches: {
         "head title": Pjax.switches.replaceNode,
         ".blocks-wrapper": Pjax.switches.sideBySide
      },
      cacheBust: false,
      scrollRestoration: true,
      switchesOptions: {
         ".blocks-wrapper": {
            classNames: {
               // class added to the old element being replaced, e.g. a fade out Pjax.switches.sideBySide
               remove: "",
               // class added to the new element that is replacing the old one, e.g. a fade in
               add: "",
               // class added on the element when navigating back
               backward: "",
               // class added on the element when navigating forward (used for new page too)
               forward: ""
            },
            callbacks: {
               removeElement: function(el) {
                  var scrolled = jQuery(window).scrollTop();
                  jQuery('.js-Pjax-remove').css('margin-top', '-' + scrolled + 'px');
                  /*alert(scrolled); */
                  //setTimeout(function(){
                  window.scrollTo(0, 0);
                  //}, 10);

               }
            }
         }
      }
   });

   headerInit(pjax);
   textImage();

   jQuery('.block.contact .right-top-grid a').click(function(){
      jQuery('html, body').animate({
         scrollTop: (jQuery(".block.form").offset().top - 120)
      }, 1200);
   });
});
